<template>
	<div class="meter-water-manage-container">
		<el-card shadow="never" class="search-card">
			<div slot="header" class="card-header">
				<span>查询条件</span>
			</div>
			<div class="flex justify-start">
				<el-form :inline="true" :model="queryParams">
					<el-form-item>
						<el-input v-model="queryParams.carNo" placeholder="必填，请填写车牌号" clearable
							style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.startTime" type="date" placeholder="开始时间"
							value-format="yyyy-MM-dd" style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.endTime" type="date" placeholder="结束时间"
							value-format="yyyy-MM-dd" style="width: 350px" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
		</el-card>
	
		<el-card shadow="never" class="table-card">
			<div slot="header" class="card-header">
				<span>出场记录</span>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column type="index" label="序号" width="50" />
				<el-table-column label="出场图" width="150" align="center">
					<template slot-scope="{ row }">
						<el-image v-if="row.outImgPath" :src="row.outImgPath" fit="cover"
							style="width:130px;height:140px" :preview-src-list="[row.outImgPath]" />
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="carNo" label="车牌号" min-width="120" align="center" />
				<el-table-column prop="enterGateName" label="入场方向" min-width="100" align="center">
					<template slot-scope="{ row }">
						<span style="color: #409EFF;"><i class="el-icon-collection" style="margin-right: 3px;font-size: 16px;"></i>{{row.enterGateName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="enterTime" label="入场时间" min-width="120" align="center" />
				<el-table-column label="出场方向/操作员" min-width="140" align="center">
					<template slot-scope="{ row }">
						<span style="color: #ff0000;"><i class="el-icon-user" style="margin-right: 3px;font-size: 16px;"></i>{{ row.outGateName }}（操作员：{{ row.outOperatorName || '-' }}）</span>
					</template>
				</el-table-column>
				<el-table-column prop="outTime" label="出场时间" min-width="120" align="center" />
				<el-table-column prop="paNum" label="停车场" min-width="120" align="center">
					<template slot-scope="{ row }">
						{{ row.machineName }}日钢停车场
					</template>
				</el-table-column>
				<el-table-column prop="carTypeNo" label="车牌类型编号" min-width="100" align="center" />
				<el-table-column prop="remark" label="说明" min-width="100" align="center" />
				<!-- <el-table-column label="操作" width="100" align="center">
					<template slot-scope="{ row }">
						<el-button v-if="row.state === '100500' && row.carInout === '3306'" type="text"
							size="small" style="color: #f56c6c" @click="exceptionCarIn(row)">异常入场</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<el-pagination :current-page="queryParams.indexId+1" :page-size="queryParams.size" :total="total"
				:page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper"
				@size-change="handleSizeChange" @current-change="handlePageChange"
				class="pagination-container" />
		</el-card>
	</div>
</template>

<script>
	import {
		randomDecimal,
		generateSign
	} from '@/api/common/parkAreaApi'
	import axios from 'axios'

	export default {
		name: 'ParkingCarIns',
		data() {
			return {
				loading: false,
				list: [],
				total: 0,
				queryParams: {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge",
					startTime: '',
					endTime: ''
				}
			}
		},
		mounted() {
			this.queryParams.startTime = this.formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
			this.queryParams.endTime = this.formatDateTime(new Date())
			this.loadData()
		},
		methods: {
			async loadData() {
				this.loading = true
				try {
					const rand = await randomDecimal()
					this.queryParams.rand = rand.toString()
					this.$delete(this.queryParams, 'sign')
					this.queryParams.sign = await generateSign(this.queryParams)
					const {
						data
					} = await axios.post('/Api/Inquire/GetOutCar', this.queryParams)
					const res = data
					this.list = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : [])
					if(this.queryParams.indexId === 0){
						this.total = this.list.length
						if(this.list.length >= 20) {
							this.getAllTotal(1)
						}
					}
				} catch (e) {
					console.error('获取出场记录失败', e)
				} finally {
					this.loading = false
				}
			},
			async getAllTotal(index) {
				try {
					const dataParams = JSON.parse(JSON.stringify(this.queryParams))
					dataParams.indexId = index
					const rand = await randomDecimal()
					dataParams.rand = rand.toString()
					this.$delete(dataParams, 'sign')
					dataParams.sign = await generateSign(dataParams)
					const { data } = await axios.post('/Api/Inquire/GetOutCar', dataParams)
					const res = data
					if(res.code === 1) {
						this.total += res.data.length;
					}
					if(res.code === 1 && res.data.length >= 20){
						await new Promise(resolve => setTimeout(resolve, 500));
						await this.getAllTotal(index+1)
					}
				} catch (e) {
					console.error('获取出场记录失败', e)
				}
			},
			handleSearch() {
				this.queryParams.indexId = 0;
				this.loadData()
			},
			handleReset() {
				this.queryParams = {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge",
					startTime: this.formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000)),
					endTime: this.formatDateTime(new Date())
				};
				this.loadData()
			},
			handleSizeChange(val) {
				this.queryParams.size = val;
				this.loadData()
			},
			handlePageChange(val) {
				this.queryParams.indexId = val - 1;
				this.loadData()
			},
			carInPayFee(carIn) {
				this.$emit('show-custom-inout', {
					type: '1102',
					carNum: carIn.carNum,
					amount: carIn.payCharge,
					payCharge: carIn.payCharge,
					paId: this.paId
				})
			},
			exceptionCarIn(row) {
				this.$confirm('请确定异常入场！', '确认操作', {
					type: 'warning'
				}).then(() => {
					/* TODO */
					console.log(row)
				}).catch(() => {})
			},
			formatDateTime(date) {
				const y = date.getFullYear()
				const m = String(date.getMonth() + 1).padStart(2, '0')
				const d = String(date.getDate()).padStart(2, '0')
				const h = String(date.getHours()).padStart(2, '0')
				const min = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
				return `${y}-${m}-${d} ${h}:${min}:${s}`
			}
		}
	}
</script>

<style lang="scss" scoped>
	.meter-water-manage-container {
		padding: 20px;
	
		.tree-container {
			min-height: 450px;
			overflow-y: auto;
			background: #fff;
			padding: 10px;
			border-radius: 4px;
		}
	
		.margin-top {
			margin-top: 20px;
		}
	
		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}
	
		.clearfix:after {
			clear: both;
		}
	}
	.tab-component {
		padding: 0;
	}
	
	.search-card {
		margin-bottom: 16px;
	}
	
	.table-card {
		margin-bottom: 0;
	}
	
	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-container {
		text-align: right;
		margin-top: 16px;
	}
</style>